import { Microfrontend } from '@cian/mf-react';
import * as React from 'react';

import * as styles from './Recommendations.css';
import { IManifestInfo } from '../../types/manifestInfo';
import classNames from 'classnames';

interface IRecommendationsProps {
  manifestInfo: IManifestInfo;
  regionId: number;
  landingType: string;
  showFullList: number;
  isRedesigned?: boolean;
}

export const Recommendations: React.FC<IRecommendationsProps> = ({
  manifestInfo,
  regionId,
  landingType,
  showFullList = 0,
  isRedesigned = false,
}) => (
  <section
    className={classNames(
      'cg-container-fluid-xs',
      isRedesigned ? styles['redesigned-container'] : styles['container'],
      !!showFullList && styles['reset-padding'],
    )}
  >
    <Microfrontend {...manifestInfo} parameters={{ regionId, landingType, showFullList }} />
  </section>
);
